import { useNavigate, useSearch } from '@tanstack/react-router';
import { db } from '../db/dexie.js';
import { FormularioProducto } from '../ui/FormularioProducto.js';
import { Pagina } from '../ui/Pagina.js';
import { useT } from '../i18n/index.js';
import { useNombreProducto } from '../i18n/productos.js';
import { anunciar } from '../lib/hecho.js';
import { volver } from '../lib/volver.js';

export function ProductoNuevo() {
  const t = useT();
  const navigate = useNavigate();
  const nombre = useNombreProducto();
  // Arriving from a scan nobody recognised, the code is already filled in; from a venta rápida,
  // the name it was sold under.
  const { codigo, nombre: vendidoComo } = useSearch({ from: '/productos/nuevo' });

  return (
    <Pagina titulo={t('producto.nuevo')} volverA="/productos">
      <FormularioProducto
        codigo={codigo}
        nombre={vendidoComo}
        lectorUsb
        // The code went on a product the shop already had: that product, with it, in the form's place.
        onYaExiste={(p) => void navigate({ to: '/productos/$productoId', params: { productoId: p.id }, replace: true })}
        // Made: back where it was asked for, the list, the scan, the quick sale, saying so (the owner,
        // 2026-10-08, a task ends where it began). Opened with nothing behind it, its own page.
        onCreado={({ productoId }) =>
          void db.productos.get(productoId).then((p) => {
            if (p) anunciar(t('producto.creado', { nombre: nombre(p) }));
            return volver({ to: `/productos/${productoId}` });
          })
        }
      />
    </Pagina>
  );
}
